<template>
  <div id="resources-view" ref="resourcesView" tabindex="0">
   <div class="bg-gray-50 rounded-md border-dashed p-2">
     <dl ref="resourceDetailsGrid" class="resource-details-grid text-left" v-show="tooltipData.fixture">
      <div class="resource-details-item resource-details-item--fixture">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Fixture
        </dt>
        <dd class="text-sm text-gray-900">
          {{tooltipData.fixture}}
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Service start time
        </dt>
        <dd class=" text-sm text-gray-900">
          {{moment.utc(tooltipData.serviceStartTime).format('YYYY/MM/DD HH:mm')}}
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Line-up
        </dt>
        <dd class=" text-sm text-gray-900">
          {{moment.utc(tooltipData.lineupTime).format('YYYY/MM/DD HH:mm')}}
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Kick-off
        </dt>
        <dd class=" text-sm text-gray-900">
          {{moment.utc(tooltipData.startTime).format('YYYY/MM/DD HH:mm')}}
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          End time
        </dt>
        <dd class=" text-sm text-gray-900">
          {{moment.utc(tooltipData.endTime).format('YYYY/MM/DD HH:mm')}}
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Input
        </dt>
        <dd class=" text-sm text-gray-900 wrap-break-word">
          {{tooltipData.inputName}} 
          <span class="text-red-500" v-show="overlappingSelectedInputNumber">
            <i class="far fa-exclamation-circle"></i>
            {{overlappingSelectedInputNumber}}
          </span>
        </dd>
      </div>
      <div class="resource-details-item">
        <dt class="text-xs uppercase font-medium text-gray-500">
          Customer/Account
        </dt>
        <dd class=" text-sm text-gray-900" v-if="tooltipData && tooltipData.account">
          {{tooltipData.customerName}} / {{tooltipData.account.name}}
        </dd>
      </div>
    </dl>
    <dt class="text-base text-blue-500" v-if="!tooltipData.fixture">
      <i class="far fa-info-circle"></i> Click the event to see details
    </dt>
   </div>
   <div id="resourceChart" ref="resourceChart"></div>
  </div>
</template>

<script>
import * as d3 from 'd3';
import moment from 'moment';
// import * as tl from '../d3-timeline';

export default {
  name: 'ResourceView2',
  props: ['dataset', 'range', 'overlappingInputs'],
  data() {
    return {
      moment,
      chart: null,
      main: null,
      mini: null,
      chartContainer: null,
      xScale: null,
      xScale2: null,
      yScale: null,
      yScale2: null,
      domain: null,
      xAxis: null,
      xAxisTop: null,
      xAxisTopEl: null,
      yAxis: null,
      brush:null,
      chartOptions: {
        width: 1000,
        height: 600,
        margin: {
          top: 2,
          right: 2,
          bottom: 2,
          left: 2,
        },
        ctrWidth: 0,
        ctrHeight: 0,
      },
      inputs: [],
      mainItems: [],
      mainItemsText: [],
      tooltipData: {},
      
      // new timeline
      events: [],
      statuses: [
        ['COMPLETED', '#FF6400'],
        ['CONFIRMED', '#90EE90'],
        ['CLIENT_CONFIRMED', '#003CFF'],
        ['RECEIVED', '#FFC400'],
        ['LIVE', '#FF6400'],
        ['PENDING', '#90EE90'],
        ['CANCELLED', '#003CFF'],
        ['LATE_CANCELLED', '#FFC400'],
        ['POSTPONED', '#FF6400'],
        ['FAILED', '#FFC400'],
        ['AWAITING_SIGNAL', '#6cdf6c']
      ],
      width: null,
      height: null,

      minuteInMs: 60000,
      hourInMs: this.minuteInMs * 60,
      dayInMs: this.hourInMs * 24,
      weekInMs: this.dayInMs * 7,

      rows: null,
      groups: null,
      zoombrush: null,
      rowsHeight: null,
      chartHeight: null,
      evenDaysWidth: null,
      groupped: 1,

      // new init later
      svgBack: null,
      svgTop: null,
      todaySvg: null,
      wrapper: null,
      svg: null,
      todaySvg: null,
      svgBottom: null,
      x: null,
      xBrush: null,
      start: null,
      end: null,
      evenDays: null,
      categories: null,
      gGooey: null,
      defs: null,
      filter: null,
      chart: null,
      g: null,
      todayCircle: null,
      todayLine: null,
      cellBack: null,
      cell: null,
      text: null,
      axisTopDay: null,
      axisTopDate: null,
      axisTopTime: null,
      axisBottomDate: null,
      brush: null,
      zoom: null,
      gb: null,
      sMax: null,
      sDay: null,
      indent: null,

      axisTopHeight: 46,
      marginTop: 62,
      cellStrokeWidth: 6,
      cellHeight: 52,
      cellWidthMin: this.cellHeight * 2,
      cellPaddingTop: 29,
      cellPaddingLeft: 10,
      gapY: 16,
      gapX: 16,
      cellColor: null,
      cellTextColor: 'white',
      cellRadius: 6,
      time: null,
      brushHeight: 49,
      sm: null,

      selector: '#resourceChart',
      eventsQuantity: 100,
      resizeObserver: null,
      resizeTimeout: null,
      layoutObserver: null,
      lastAvailableHeight: 0,
      viewportResizeHandler: null,
      isRendering: false,
      isResizing: false,
      resizeRafId: null,
    };
  },
  computed: {
    dateRange() {
      return {
        start: this.range.start || this.range.startDate,
        end: this.range.end || this.range.endDate,
      };
    },
    overlapingInputsOverallNumber() {
      return this.dataset.filter((event) => {
        return event.overlappingInputs.length > 0;
      })
      .map(event => event.overlappingInputs.length)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    },
    overlappingSelectedInputNumber() {
      if (!this.tooltipData.id) return 0;

      return this.tooltipData.overlappingInputs.length;
    },
    processedRange() {
      return {
        start: moment.utc(this.dateRange.start).add(1, 'days').format(),
        end: moment.utc(this.dateRange.end).subtract(1, 'days').endOf('day').format(),
      };
    },
  },

  watch: {
    dataset: {
      deep: true,
      handler() {
        this.scheduleRender();
      },
    },
    range: {
      deep: true,
      handler() {
        this.scheduleRender();
      },
    },
  },

  created() {
    // d3.timeline = tl.timeline;
    console.log('resource view', this.dataset, this.range, this.overlappingInputs);
  },

  mounted() {
    this.setupLayoutObserver();
    this.setupResizeObserver();
    this.updateAvailableHeight();
    this.scheduleRender();
  },

  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.layoutObserver) this.layoutObserver.disconnect();
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
    if (this.viewportResizeHandler) {
      window.removeEventListener('resize', this.viewportResizeHandler);
    }
  },

  methods: {
    updateAvailableHeight() {
      const root = this.$refs.resourcesView;
      if (!root) return;

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const topOffset = root.getBoundingClientRect().top;
      const bottomGap = 12;
      const minHeight = 460;
      const availableHeight = Math.max(minHeight, Math.floor(viewportHeight - topOffset - bottomGap));

      if (Math.abs(availableHeight - this.lastAvailableHeight) < 2) return;
      this.lastAvailableHeight = availableHeight;
      root.style.height = `${availableHeight}px`;
    },
    setupLayoutObserver() {
      this.viewportResizeHandler = () => {
        this.updateAvailableHeight();
        this.scheduleResizeRefresh();
      };
      window.addEventListener('resize', this.viewportResizeHandler);

      if (typeof ResizeObserver === 'undefined') return;

      this.layoutObserver = new ResizeObserver(() => {
        this.updateAvailableHeight();
        this.scheduleResizeRefresh();
      });

      if (this.$refs.resourcesView) this.layoutObserver.observe(this.$refs.resourcesView);
      if (this.$refs.resourceDetailsGrid) this.layoutObserver.observe(this.$refs.resourceDetailsGrid);
    },
    setupResizeObserver() {
      const chartHolder = this.$refs.resourceChart;
      if (!chartHolder || typeof ResizeObserver === 'undefined') return;

      this.resizeObserver = new ResizeObserver(() => {
        this.scheduleResizeRefresh();
      });
      this.resizeObserver.observe(chartHolder);
    },
    scheduleResizeRefresh() {
      if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
      this.resizeRafId = requestAnimationFrame(() => {
        this.resizeRafId = null;
        this.refreshChartLayout();
      });
    },
    scheduleRender() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.updateAvailableHeight();
        this.renderChart();
      }, 120);
    },
    getChartDimensions() {
      const chartHolder = this.$refs.resourceChart;
      if (!chartHolder) return null;
      const width = chartHolder.clientWidth;
      const height = chartHolder.clientHeight;
      if (!width || !height) return null;
      return { width, height };
    },
    clearChart() {
      d3.select(this.selector).selectAll('*').remove();
      this.chart = null;
      this.g = null;
      this.brush = null;
      this.gb = null;
      this.zoom = null;
      this.svg = null;
      this.svgTop = null;
      this.svgBack = null;
      this.todayLine = null;
      this.todayCircle = null;
      this.x = null;
      this.xBrush = null;
      this.gGooey = null;
      this.wrapper = null;
    },
    renderChart() {
      if (this.isRendering) return;
      if (!this.dataset || !this.dataset.length) {
        this.clearChart();
        return;
      }
      const dimensions = this.getChartDimensions();
      if (!dimensions) return;
      this.width = dimensions.width;
      this.height = dimensions.height;
      this.isRendering = true;
      this.clearChart();
      this.$nextTick(() => {
        try {
          this.initTimeline2(this.dataset);
        } finally {
          this.isRendering = false;
        }
      });
    },
    refreshChartLayout() {
      if (this.isRendering || this.isResizing) return;
      this.updateAvailableHeight();
      const dimensions = this.getChartDimensions();
      if (!dimensions) return;
      this.width = dimensions.width;
      this.height = dimensions.height;

      if (!this.chart || !this.x || !this.xBrush || !this.svg || !this.svgTop || !this.svgBottom || !this.brush || !this.gb || !this.g || !this.zoom) {
        this.scheduleRender();
        return;
      }

      this.isResizing = true;
      try {
        const width = this.width;
        const height = this.height;
        this.x.range([0, width]);
        this.xBrush.range([0, width]);

        this.svgTop.select('.axisTopDay').call(this.axisTopDay);
        this.svgTop.select('.axisTopDate').call(this.axisTopDate);
        this.svgTop.select('.axisTopTime').call(this.axisTopTime);
        this.svgBottom.select('.axisBottomDate').call(this.axisBottomDate);

        if (this.gGooey) {
          this.gGooey.select('rect').attr('width', width);
          this.gGooey.selectAll('circle').attr('cx', d => this.xBrush(d.startTime));
        }

        this.zoom
          .translateExtent([[0, 0], [width, height]])
          .extent([[0, 0], [width, height]]);
        this.svg.call(this.zoom);

        this.brush.extent([[0, 1], [width, this.brushHeight]]);
        this.gb
          .call(this.brush)
          .call(this.brush.move, this.x.domain().map(i => this.xBrush(i)));

        this.y();
        this.chart.selectAll('g')
          .attr('transform', d => `translate(${this.x(d.serviceStartTime)}, ${d.y})`);
        this.g.selectAll('.cellBack')
          .attr('width', d => this.cellWidth(d));
        this.g.selectAll('.cell')
          .attr('width', d => this.cellWidthFront(d))
          .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime));
        this.g.selectAll('foreignObject')
          .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime))
          .attr('width', d => this.cellWidthFront(d));

        if (this.todayLine) this.todayLine.attr('x1', this.x(new Date())).attr('x2', this.x(new Date()));
        if (this.todayCircle) this.todayCircle.attr('cx', this.x(new Date()));
        if (this.svgBack) {
          this.evenDaysWidth = this.x(this.dayInMs) - this.x(0);
          this.svgBack.selectAll('rect').attr('x', d => this.x(d)).attr('width', this.evenDaysWidth);
        }
      } finally {
        this.isResizing = false;
      }
    },
    initTimeline2(dataset) {
      const minuteInMs = 60000
      const hourInMs = minuteInMs * 60
      const dayInMs = hourInMs * 24
      const weekInMs = dayInMs * 7
      this.minuteInMs = 60000;
      this.hourInMs = this.minuteInMs * 60;
      this.dayInMs = this.hourInMs * 24;
      this.weekInMs = this.dayInMs * 7;

      let events = []
      const eventsQuantity = 100
      const statuses = [
        ['COMPLETED', '#0033ff'],
        ['CONFIRMED', 'lightgreen'],
        ['CLIENT_CONFIRMED', '#ff9000'],
        ['RECEIVED', '#EA3CF7'],
        ['LIVE', '#0f0'],
        ['PENDING', '#FFFE54'],
        ['CANCELLED', '#999999'],
        ['LATE_CANCELLED', '#8b0000'],
        ['POSTPONED', '#999999'],
        ['FAILED', '#f00'],
        ['AWAITING_SIGNAL', '#6cdf6c']
      ]


      // init random data
      this.events = dataset.map((event) => {
        const startTime = moment.utc(event.serviceStartTime).diff(moment.utc(event.startTime));

        const newEvent = {
          ...event,
          serviceStartTime: moment.utc(event.serviceStartTime).toDate(),
          serviceEndTime: moment.utc(event.serviceEndTime).toDate(),
          startTime: moment.utc(event.startTime).toDate(),
          endTime: moment.utc(event.endTime).toDate(),
          description: event.description,
          category: event.inputName,
          status: event.status,
          title: event.fixture,
          groupId: event.gorupId
        };
        return newEvent;
      });
      console.log('events', this.events);
      const selector = '#resourceChart';
      this.events = this.events.sort((a, b) =>
        a.serviceStartTime - b.serviceStartTime || a.serviceEndTime - b.serviceEndTime
      )
      this.categories = [...new Set(this.events.map(i => i.inputName))].sort((a, b) => d3.ascending(a, b))

      const dimensions = this.getChartDimensions();
      if (!dimensions) return;
      let { width, height } = dimensions;
      this.width = width;
      this.height = height;

      const axisTopHeight = 46
      const marginTop = 62
      const cellStrokeWidth = 6
      this.cellHeight = 32
      const cellWidthMin = this.cellHeight * 2
      const cellPaddingTop = 29
      const cellPaddingLeft = 10
      this.gapY = 4
      const gapX = 16
      const cellColor = (d) => statuses[statuses.map(i => i[0]).indexOf(d.status)][1]
      const cellTextColor = 'white'
      const cellRadius = 6
      const time = d3.timeFormat('%H:%M')
      const brushHeight = 49
      const sm = width * dayInMs / 320
      let rows, groups, zoombrush, rowsHeight, chartHeight, evenDaysWidth
      let groupped = 1
      let indent = this.gapY

      this.svgBack = d3
        .select(selector)
        .append('svg')
        .attr('class', 'svgBack')

      this.svgTop = d3.select(selector)
        .append('svg')
        .attr('width', '100%')
        .attr('height', axisTopHeight)

      const wrapper = d3.select(selector)
        .append('div')
        .attr('class', 'wrapper')
        .style('overflow-y', 'auto')
      this.wrapper = wrapper;

      this.svg = wrapper.append('svg')
        .attr('width', '100%')

      const todaySvg = d3.select(selector)
        .append('svg')
        .attr('class', 'todaySvg')

      const svgBottom = d3.select(selector)
        .append('svg')
        .attr('width', '100%')
        .attr('height', brushHeight)
        .attr('class', 'svgBottom')

console.log('events[0].serviceStartTime', moment.utc(this.dateRange.start).startOf('day').toString(), d3.min(this.events.map(i => i.serviceStartTime)));
      const dmn = [
        // d3.min(this.events.map(i => i.serviceStartTime)),
        moment.utc(this.dateRange.start).toDate(),
        moment.utc(this.dateRange.end).toDate(),
        // this.dateRange.start,
        // this.dateRange.end
        d3.max(this.events.map(i => i.serviceEndTime))
      ]

      this.x = d3
        .scaleTime()
        .domain(dmn)
        .range([0, width])

      this.xBrush = d3
        .scaleTime()
        .domain([
          this.x.invert(-this.gapY),
          this.x.invert(width + this.gapY)
        ])
        .range([0, width])

      const start = this.xBrush.domain()[0]// d3.timeDay.offset(this.xBrush.domain()[0], -1)
      const end = this.xBrush.domain()[1]
      const evenDays = d3.timeDay.range(start, end, 2)

      this.svgBack.selectAll('rect')
        .data(evenDays)
        .join('rect')
        .attr('class', 'evenDays')

      const gGooey = svgBottom
        .append("g")
        .style("filter", 'url(#gooey)')
      this.gGooey = gGooey;

      const defs = svgBottom.append('defs')
      const filter = defs.append('filter').attr('id','gooey')

      filter.append('feGaussianBlur')
        .attr('in','SourceGraphic')
        .attr('stdDeviation','10')
        .attr('result','blur-sm')

      filter.append('feColorMatrix')
        .attr('in','blur-sm')
        .attr('mode','matrix')
        .attr('values','1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 75 -10')
        .attr('result','gooey')

      filter.append('feBlend')
        .attr('in','SourceGraphic')
        .attr('in2','gooey')
        .attr('operator','over')

      gGooey.append('rect')
        .style('fill', 'none')
        .attr('width', width)
        .attr('height', brushHeight)

      gGooey
        .selectAll('circle')
        .data(this.events)
        .join('circle')
        .attr('cx', d => this.xBrush(d.startTime))
        .attr('cy', 17)
        .attr('r', d => {
          // this.xBrush(d.startTime)
          if (!d.overlappingInputs) return 3;
          console.log('....', d);
          const size = d.overlappingInputs.length > 0 ? 5: 3;
          return size;
        })
        .style('fill', d => {
          // this.xBrush(d.startTime)
          console.log('....', d);
          if (!d.overlappingInputs) return '#ff6400';
          const color = d.overlappingInputs.length > 0 ? 'red' : '#000';
          return color;
        })


      this.chart = this.svg.append('g')
        // .attr('transform', 'translate(0, -13)') // move events group up

      this.g = this.chart
        .selectAll('g')
        .data(this.events)
        .join('g')
        .attr('class', d => d.overlappingInputs.length > 0 ? 'overlapping' : '')
        .on('mouseenter', e => {
          console.log('tooltip', this.tooltipData = e.target.__data__);
          this.tooltipData = e.target.__data__
        })
        .on('click', function() {
          const cb = d3.select(this).select('.cellBack')
          console.log('clicked',cb, this)
          if (cb.classed('selected')) {
            cb.classed('selected', false)
          } else {
            d3.selectAll('.selected').classed('selected', false)
            cb.classed('selected', true)
          }
        })

      this.todayCircle = todaySvg.append('circle')
        .attr('cy', 4)
        .attr('r', 4)
        .style('fill', '#FF6600')
        .attr('stroke', 'white')

      this.todayLine = this.svg.append('line')
        .attr('y1', 0)
        .attr('y2', '100%')
        .attr('vector-effect', 'non-scaling-stroke')
        .attr('shape-rendering', 'crispEdges')
        .attr('stroke', '#FF6600')

      this.cellBack = this.g
        .append('rect')
        .attr('width', d => this.cellWidth(d))
        .attr('height', this.cellHeight)
        .attr('rx', cellRadius)
        .attr('ry', cellRadius)
        .attr('class', d => d.status === 'LIVE' ? 'cellBack live' : 'cellBack')
        .style('fill', d => d3.interpolate('white', cellColor(d))(0.4))

      this.cell = this.g
        .append('rect')
        .attr('height', this.cellHeight)
        .attr('rx', cellRadius)
        .attr('ry', cellRadius)
        .attr('class', 'cell')
        .style('fill', d => cellColor(d))

      const text = this.g
        .append('foreignObject')
        .attr('height', this.cellHeight)
        .attr('class', 'text')

      text.append('xhtml:div')
        .attr('class', 'category')
        .html(d => {
          if (d.groupId) {
            const htmlCode = `
              <svg width='18' height='11'>
                <rect y='3' width='1' height='6' rx='1' ry='1' fill='white'/>
                <rect x='3' y='1' width='10' height='10' rx='1' ry='1' fill='white'/>
              </svg>
              <a href='#'>${d.category}</a>
            `
            return htmlCode
          } else {
            return `<a href='#'>${d.category}</a>`
          }
        })

      text.selectAll('a')
        .on('click', () => {
          this.groupped = 1
          this.events = this.events.sort((a, b) => d3.ascending(a.category, b.category))
          console.log('categories', this.categories)
          groups = this.categories.map(i => [i, [-Infinity]])
          text.selectAll('.category').remove()
          this.cellHeight = 37
          this.g.selectAll('rect')
            .attr('height', this.cellHeight)
          this.y()
          this.chart.selectAll('g')
            .transition()
            .attr('transform', d => `translate(${this.x(d.serviceStartTime)}, ${d.y})`)
          groups.forEach((d, i) => {
            console.log(this.groupClassName(d[0]))
            const lineIndex = groups.slice(0, i + 1).map(j => j[1]).flat().length
            const lineY = (this.gapY + 1) * (i + 1) + (this.cellHeight + this.gapY) * lineIndex
            this.svg.insert('line', 'g')
              .transition()
              .attr('y1', lineY)
              .attr('y2', lineY)
              .attr('x1', 0)
              .attr('x2', '100%')
              .attr('shape-rendering', 'crispEdges')
              .attr('stroke', '#C3C3C3')
              .attr('class', this.groupClassName(d[0]))
            const textIndex = groups.slice(0, i).map(j => j[1]).flat().length
            const textY = (this.gapY + 1) * (i + 1) + (this.cellHeight + this.gapY) * textIndex + 22
            this.svg.append('text')
              .transition()
              .attr('x', 10)
              .attr('y', textY)
              .attr('style', 'font-size: 13px; color: #707070; text-transform: uppercase')
              .attr('class', this.groupLabelClassName(d[0]))
              .text(d[0])
          })
        })

      text.append('xhtml:div')
        .html(d => `<b>${time(d.startTime)} − ${time(d.endTime)}</b> ${d.title}`)

      text.append('xhtml:div')
        .html(d => d.description)
        .attr('style', 'font-size: 11px; top: -7px; position: relative')


      this.axisTopDay = d3
        .axisTop(this.x)
        .ticks(d3.timeDay)
        .tickSize(0)
        .tickFormat(d3.timeFormat('%A'))

      this.axisTopDate = d3
        .axisTop(this.x)
        .ticks(d3.timeDay)
        .tickSize(0)
        .tickFormat(d3.timeFormat('%d/%m/%Y'))

      this.axisTopTime = d3
        .axisTop(this.x)
        .tickSize(2)
        .tickPadding(3)
        .tickFormat(time)
        .ticks(Math.round(width / 120))

      this.axisBottomDate = d3
        .axisTop(this.xBrush)
        .ticks(d3.timeDay)
        .tickSize(5)
        .tickPadding(4)
        .tickFormat(d3.timeFormat('%d/%m/%Y'))

      this.svgTop
        .append('g')
        .attr('transform', `translate(${0}, ${21})`)
        .attr('class', 'axisTopDay')
        .call(this.axisTopDay)

      this.svgTop
        .append('g')
        .attr('transform', `translate(${0}, ${32})`)
        .attr('class', 'axisTopDate')
        .call(this.axisTopDate)

      this.svgTop
        .append('g')
        .attr('transform', `translate(${0}, ${45})`)
        .attr('class', 'axisTopTime')
        .call(this.axisTopTime)

      svgBottom.append('line')
        .attr('y1', 1)
        .attr('y2', 1)
        .attr('x1', 0)
        .attr('x2', '100%')
        .attr('vector-effect', 'non-scaling-stroke')
        .attr('shape-rendering', 'crispEdges')
        .attr('stroke', '#C6C6C6')

      svgBottom
        .append("g")
        .attr('transform', `translate(${0}, ${brushHeight})`)
        .attr('class', 'axisBottomDate')
        .call(this.axisBottomDate)
        .select('.domain')
        .remove()

      this.brush = d3
        .brushX()
        .extent([[0, 1], [width, brushHeight]])
        .on('brush', this.brushed)

      this.zoom = d3.zoom()
        .scaleExtent([1, (dmn[1] - dmn[0]) / hourInMs])
        .translateExtent([[0, 0], [width, height]])
        .extent([[0, 0], [width, height]])
        .filter((event) => event.altKey || event.type === 'dblclick' || event.type === 'touchmove' || event.type === 'mousemove' || event.type === 'mousedown' || event.type === 'mouseup' )
        .on("zoom", this.zoomed)

      let sMax = [this.xBrush(this.xBrush.invert(width) - sm), width]
      let sDay = [0, width]

      this.gb = svgBottom
        .append('g')
        .attr('class', 'brush')
        .call(this.brush)
        .call(this.brush.move, sDay)

      this.svg.call(this.zoom);
      // on("wheel.zoom", null);


      // group by category
      this.groupped = 1
      this.events = this.events.sort((a, b) => d3.ascending(a.category, b.category))
      console.log('categories', this.categories)
      groups = this.categories.map(i => [i, [-Infinity]])
      text.selectAll('.category').remove()
      // this.cellHeight = 37
      this.g.selectAll('rect')
        .attr('height', this.cellHeight)
      this.y()
      this.chart.selectAll('g')
        .transition()
        .attr('transform', d => `translate(${this.x(d.serviceStartTime)}, ${d.y})`)

      const step = this.cellHeight + this.gapY // event Y position
      this.groups.forEach((d, i) => {
        console.log(this.groupClassName(d[0]))
        const lineIndex = this.groups.slice(0, i + 1).map(j => j[1]).flat().length
        const lineY = (this.gapY + 1) * (i + 1) + step * lineIndex
        this.svg.insert('line', 'g')
          .transition()
          .attr('y1', lineY)
          .attr('y2', lineY)
          .attr('x1', 0)
          .attr('x2', '100%')
          .attr('shape-rendering', 'crispEdges')
          .attr('stroke', '#C3C3C3')
          .attr('class', this.groupClassName(d[0]))
        const textIndex = this.groups.slice(0, i).map(j => j[1]).flat().length
        const textY = (this.gapY + 1) * (i + 1) + step * textIndex + 20
        this.svg.append('text')
          .transition()
          .attr('x', 10)
          .attr('y', textY)
          .attr('style', 'font-size: 13px; color: #707070; text-transform: uppercase')
          .attr('class', this.groupLabelClassName(d[0]))
          .text(d[0])
      })
    },

    brushed(e) {
      if (this.zoombrush || this.isRendering || this.isResizing) return
      if (!this.brush || !this.gb || !this.x || !this.xBrush || !this.svg || !this.svgTop || !this.chart || !this.g) return
      this.zoombrush = 1
      const s = e.selection
      if (!s || s.length < 2) {
        this.zoombrush = 0
        return
      }
      if (this.xBrush.invert(s[1]) - this.xBrush.invert(s[0]) < this.hourInMs) {
        this.gb.call(this.brush.move, this.x.domain().map(i => this.xBrush(i)))
      } else {
        this.x.domain(s.map(this.xBrush.invert, this.xBrush))
        this.y();
        // this.xBrush.domain([
        //   d3.timeMillisecond.offset(dmn[0], -(x.invert(indent) - x.invert(0))),
        //   x.invert(d3.max(rows) + this.gapY)
        // ])
        // svgBottom.select('.axisBottomDate').call(axisBottomDate)
        this.svgTop.select('.axisTopDay').call(this.axisTopDay)
        this.svgTop.select('.axisTopDate').call(this.axisTopDate)
        this.svgTop.select('.axisTopTime').call(this.axisTopTime)
        this.chart.selectAll('g')
          .attr('transform', d => `translate(${this.x(d.serviceStartTime)}, ${d.y})`)
        this.g.selectAll('.cellBack')
          .attr('width', d => this.cellWidth(d))
        this.g.selectAll('.cell')
          .attr('width', d => this.cellWidthFront(d))
          .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime))
        this.g.selectAll('foreignObject')
          .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime))
          .attr('width', d => this.cellWidthFront(d))
        if (this.todayLine) this.todayLine.attr('x1', this.x(new Date())).attr('x2', this.x(new Date()))
        if (this.todayCircle) this.todayCircle.attr('cx', this.x(new Date()))
        // console.log('evenDaysWidth', this.dayInMs, this.x(this.dayInMs))
        this.evenDaysWidth = this.x(this.dayInMs) - this.x(0)
        this.svgBack.selectAll('rect').attr('x', d => this.x(d)).attr('width', this.evenDaysWidth)
        this.svg.call(
          this.zoom.transform,
          d3.zoomIdentity.scale(this.width / (s[1] - s[0])).translate(-s[0], 0)
        )
      }
      this.zoombrush = 0
    },

    zoomed(e) {
      if (this.zoombrush || this.isRendering || this.isResizing) return
      if (!this.brush || !this.gb || !this.x || !this.xBrush || !this.svg || !this.svgTop || !this.chart || !this.g) return
      this.zoombrush = 1
      const t = e.transform
      if (!t) {
        this.zoombrush = 0
        return
      }
      this.x.domain(t.rescaleX(this.xBrush).domain())
      this.y()
      this.svgTop.select('.axisTopDay').call(this.axisTopDay)
      this.svgTop.select('.axisTopDate').call(this.axisTopDate)
      this.svgTop.select('.axisTopTime').call(this.axisTopTime)
      this.chart.selectAll('g')
        .attr('transform', d => `translate(${this.x(d.serviceStartTime)}, ${d.y})`)
      this.g.selectAll('.cellBack')
        .attr('width', d => this.cellWidth(d))
      this.g.selectAll('.cell')
        .attr('width', d => this.cellWidthFront(d))
        .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime))
      this.g.selectAll('foreignObject')
        .attr('x', d => this.x(d.startTime) - this.x(d.serviceStartTime))
        .attr('width', d => this.cellWidthFront(d))
      if (this.todayLine) this.todayLine.attr('x1', this.x(new Date())).attr('x2', this.x(new Date()))
      if (this.todayCircle) this.todayCircle.attr('cx', this.x(new Date()))
      this.evenDaysWidth = this.x(this.dayInMs) - this.x(0)
      console.log('evenDaysWidth', this.dayInMs, this.x(this.dayInMs))
      this.svgBack.selectAll('rect').attr('x', d => this.x(d)).attr('width', this.evenDaysWidth)
      this.gb.call(this.brush.move, this.xBrush.range().map(t.invertX, t))
      this.zoombrush = 0
    },
    cellWidth(d) {
      return d3.max([
        (this.x(d.startTime) - this.x(d.serviceStartTime)) + this.cellWidthMin + (this.x(d.serviceEndTime) - this.x(d.endTime)),
        this.x(d.serviceEndTime) - this.x(d.serviceStartTime)
      ])
    },

    cellWidthFront(d) {
      return d3.max([
        this.cellWidthMin,
        this.x(d.endTime) - this.x(d.startTime)
      ])
    },
    groupClassName(category) {
      const normalized = String(category || '').replace(/[^A-Za-z0-9_-]/g, '');
      return `rv2-group-${normalized || 'unknown'}`;
    },
    groupLabelClassName(category) {
      return `${this.groupClassName(category)}label`;
    },

    y() {
      this.rows = [-Infinity]
      this.groups = this.categories.map(i => [i, [-Infinity]])
      const start = (d) => this.x(d.serviceStartTime)
      const step = this.cellHeight + this.gapY // event Y position
      const chartContainerHeight = this.$refs.resourceChart ? this.$refs.resourceChart.clientHeight : this.height;
      const h = chartContainerHeight - this.axisTopHeight - this.brushHeight
      console.log('step 1', step, h);
      if (!this.groupped) {
        this.events.forEach(d => {
          const findIndex = this.rows.findIndex(i => i < start(d))
          if (findIndex >= 0) {
            this.rows[findIndex] = start(d) + this.cellWidth(d) + this.gapX
            d.y = this.gapY + step * findIndex
          } else {
            this.rows.push(start(d) + this.cellWidth(d) + this.gapX)
            d.y = this.gapY + step * (this.rows.length - 1)
          }
        })
        this.rowsHeight = this.gapY + step * this.rows.length
      } else {
        this.events.forEach(d => {
          let group = this.groups[this.categories.indexOf(d.category)][1]
          const index = this.categories.indexOf(d.category)
          const indx = this.groups.slice(0, index).map(i => i[1]).flat().length
          const findIndex = group.findIndex(i => i < start(d))
          if (findIndex >= 0) {
            group[findIndex] = start(d) + this.cellWidth(d) + this.gapX
            d.y = this.gapY * (index + 1) + step * (indx + findIndex) + index
          } else {
            group.push(start(d) + this.cellWidth(d) + this.gapX)
            d.y = this.gapY * (index + 1) + step * (indx + group.length - 1) + index
            console.log('step 2 d.y', step, h, this.gapY, (indx + group.length - 1), index, indx);
          }
        })
        this.groups.forEach((d, i) => {
          const lineIndex = this.groups.slice(0, i + 1).map(j => j[1]).flat().length
          const lineY = (this.gapY + 1) * (i + 1) + step * lineIndex
          
            console.log('step 2 lineY', lineIndex, lineY, (this.gapY + 1) * (i + 1));
          this.svg.select('.' + this.groupClassName(d[0]))
            .attr('y1', lineY)
            .attr('y2', lineY)
          const textIndex = this.groups.slice(0, i).map(j => j[1]).flat().length
          const textY = (this.gapY + 1) * (i + 1) + step * textIndex + 20
          this.svg.select('.' + this.groupLabelClassName(d[0]))
            .attr('y', textY)
          this.rowsHeight = lineY - 1
        })
      }
      this.chartHeight = this.rowsHeight < h ? '100%' : this.rowsHeight
      this.svg.attr('height', this.chartHeight)
    },
  },
};
</script>
<style>
#resources-view {
  width: 100%;
  min-height: 460px;
  display: flex;
  flex-direction: column;
}
#resourceChart {
  position: relative;
  width: 100%;
  min-height: 320px;
  flex: 1 1 auto;
  overflow: hidden;
}

.resource-details-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  column-gap: 0.5rem;
  row-gap: 1rem;
}

.resource-details-item--fixture {
  grid-column: span 1 / span 1;
}


.axisTopDay *, .axisLeft * {
  font-size: 13px;
  color: #707070;
}

.axisTopDate *, .axisTopTime *, .axisBottomDate * {
  font-size: 10px;
}

.axisTopDay *, .axisTopDate * {
  text-anchor: start;
  stroke: none;
}

.axisLeft * {
  text-transform: uppercase;
}

#resourceChart, #resourceChart svg {
  display: block;
}


.live {
  paint-order: stroke;
  stroke: black;
  stroke-linejoin: round;
  stroke-width: 6px;
}

.selected {
  paint-order: stroke;
  stroke: #FF6400;
  stroke-linejoin: round;
  stroke-width: 6px;
}
.overlapping .cellBack {
  paint-order: stroke;
  stroke: red;
  stroke-linejoin: round;
  stroke-width: 6px;
}

.selection {
  fill: #F4670C;
  stroke: #F4670C;
}

.text {
  padding: 0px 10px;
}

.text * {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: white;
}

a {
  text-decoration: none;
  text-transform: uppercase;
}

b {
  font-weight: bold;
}

.category {
  display: flex;
  font-size: 11px;
}

.categoryLabel {
  text-transform: uppercase;
}

.evenDays {
  fill: #F3F2F5;
  fill-opacity: 0.4;
  height: 100%;
}

.svgBack {
  position: absolute;
  z-index: -9;
  width: 100%;
  height: 100%;
}

.svgBottom {
  background-color: white;
}

.todaySvg {
  position: absolute;
  top: 41px;
  left: 0px;
  width: 100%;
  height: 8px;
}

.wrapper {
  height: calc(100% - 95px);
  width: 100%;
}

@media (min-width: 640px) {
  .resource-details-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .resource-details-item--fixture {
    grid-column: span 2 / span 2;
  }
}

@media (min-width: 1024px) {
  .resource-details-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1280px) {
  .resource-details-grid {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
}
/* // #timeline3 {
//   svg {
//     min-height: 300px;
//   }
// }
// .brush .selection {
//     stroke: gray;
//     fill: dodgerblue;
//     fill-opacity: .365;
//     max-height: 100%;
// }
// .mini .overlay {
//   background: #efefef;
// }
// .xaxis {
//   color: #999;
// }

// .resourceItem {
//   // opacity: 0.5;
//   text {
//     // color: #fff;
//     font-size: 11px;
//   }
//   &.overlapping {
//     filter: contrast(1.5);
//     opacity: .6;
//   }
// } */
</style>
